import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const PRESET = {
  gmail: ["Gmail", "smtp.gmail.com", 587, "starttls"],
  outlook: ["Outlook / Hotmail", "smtp.office365.com", 587, "starttls"],
  aruba: ["Aruba", "smtps.aruba.it", 465, "ssl"],
  libero: ["Libero", "smtp.libero.it", 465, "ssl"],
};
const L = ({ children }) => <span className="mb-1 block text-xs font-semibold text-slate-600">{children}</span>;

export const CasellaPostaSettings = ({ f, setF, isAdmin }) => {
  const set = (k, v) => setF((s) => ({ ...s, [k]: v }));
  const preset = (k) => {
    const [, host, porta, sic] = PRESET[k];
    setF((s) => ({ ...s, smtp_host: host, smtp_porta: porta, smtp_sicurezza: sic }));
  };
  return (
    <div className="mt-5 border-t border-slate-100 pt-4" data-testid="casella-posta-settings">
      <label className="flex items-center gap-2.5 text-sm font-medium">
        <Checkbox disabled={!isAdmin} checked={Boolean(f.usa_smtp)} onCheckedChange={(v) => set("usa_smtp", Boolean(v))} data-testid="smtp-attivo-check" />
        Invia dalla mia casella di posta (con il file Excel allegato)
      </label>
      {!f.usa_smtp && <p className="mt-1 pl-7 text-xs text-slate-500">Se non la attivi, l'email parte dall'indirizzo del gestionale con il link per scaricare il file.</p>}
      {f.usa_smtp && (
        <div className="mt-3 grid gap-3 sm:grid-cols-2">
          <div className="sm:col-span-2"><L>La tua casella è di</L>
            <Select onValueChange={preset} disabled={!isAdmin}>
              <SelectTrigger data-testid="smtp-preset-select"><SelectValue placeholder="Scegli per compilare server e porta" /></SelectTrigger>
              <SelectContent>{Object.entries(PRESET).map(([k, p]) => <SelectItem key={k} value={k}>{p[0]}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div><L>Server di posta in uscita (SMTP)</L><Input disabled={!isAdmin} value={f.smtp_host || ""} onChange={(e) => set("smtp_host", e.target.value)} placeholder="smtp.esempio.it" data-testid="smtp-host-input" /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><L>Porta</L>
              <Select value={String(f.smtp_porta || 587)} onValueChange={(v) => set("smtp_porta", Number(v))} disabled={!isAdmin}>
                <SelectTrigger data-testid="smtp-porta-select"><SelectValue /></SelectTrigger>
                <SelectContent>{[587, 465, 25, 2525].map((p) => <SelectItem key={p} value={String(p)}>{p}</SelectItem>)}</SelectContent>
              </Select>
            </div>
            <div><L>Sicurezza</L>
              <Select value={f.smtp_sicurezza || "starttls"} onValueChange={(v) => set("smtp_sicurezza", v)} disabled={!isAdmin}>
                <SelectTrigger data-testid="smtp-sicurezza-select"><SelectValue /></SelectTrigger>
                <SelectContent><SelectItem value="starttls">STARTTLS</SelectItem><SelectItem value="ssl">SSL/TLS</SelectItem></SelectContent>
              </Select>
            </div>
          </div>
          <div><L>Utente (di solito la tua email)</L><Input disabled={!isAdmin} value={f.smtp_utente || ""} onChange={(e) => set("smtp_utente", e.target.value)} autoComplete="off" data-testid="smtp-utente-input" /></div>
          <div><L>Password</L><Input disabled={!isAdmin} type="password" value={f.smtp_password || ""} onChange={(e) => set("smtp_password", e.target.value)} autoComplete="new-password"
            placeholder={f.smtp_password_impostata ? "Già salvata: scrivi solo per cambiarla" : "Password della casella"} data-testid="smtp-password-input" /></div>
          <div className="sm:col-span-2"><L>Email del mittente (se diversa dall'utente)</L><Input disabled={!isAdmin} type="email" value={f.smtp_mittente || ""} onChange={(e) => set("smtp_mittente", e.target.value)} placeholder="es. amministrazione@tuonegozio.it" data-testid="smtp-mittente-input" /></div>
          <p className="text-xs text-slate-500 sm:col-span-2">Gmail e Outlook chiedono una "password per le app", da creare nelle impostazioni di sicurezza del tuo account. La password viene salvata cifrata.</p>
        </div>
      )}
    </div>
  );
};
